import { useEffect, useRef } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  jsonLd?: Record<string, unknown>[];
}

const siteUrl: string =
  (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && ((import.meta as Record<string, unknown>).env as Record<string, string>).VITE_SITE_URL) || '';

export default function SEO({ title, description, keywords, canonicalUrl, jsonLd }: SEOProps) {
  const jsonLdRef = useRef<string[]>([]);

  useEffect(() => {
    document.title = title;

    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]') as HTMLMetaElement | null;
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }

    if (canonicalUrl) {
      let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = canonicalUrl;
    }

    document.querySelectorAll('script[data-seo-jsonld]').forEach((el) => el.remove());
    jsonLdRef.current = [];

    if (jsonLd && jsonLd.length > 0) {
      jsonLd.forEach((ld, index) => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(ld);
        script.setAttribute('data-seo-jsonld', `seo-${index}`);
        document.head.appendChild(script);
        jsonLdRef.current.push(`seo-${index}`);
      });
    }

    return () => {
      jsonLdRef.current.forEach((id) => {
        const el = document.querySelector(`script[data-seo-jsonld="${id}"]`);
        if (el) el.remove();
      });
    };
  }, [title, description, keywords, canonicalUrl, jsonLd]);

  return null;
}

export { siteUrl };